"use client";
import React from "react";
import { lockScroll, unlockScroll } from "../utilities/scroll/index.js";
const useScrollLock = (options) => {
    const { containerRef, originRef } = options || {};
    const [locked, setLocked] = React.useState(false);
    const handleLockScroll = React.useCallback(() => {
        lockScroll({
            containerEl: containerRef?.current,
            originEl: originRef?.current,
            cb: () => setLocked(true),
        });
    }, [containerRef, originRef]);
    const handleUnlockScroll = React.useCallback(() => {
        unlockScroll(() => setLocked(false));
    }, []);
    return React.useMemo(() => ({
        scrollLocked: locked,
        lockScroll: handleLockScroll,
        unlockScroll: handleUnlockScroll,
    }), [locked, handleLockScroll, handleUnlockScroll]);
};
export default useScrollLock;
